const wsRef = { current: null };

export default wsRef;
